/**
 * Studio media provider switch. Client-safe (no Node imports).
 *
 * "ark" (default): the original BytePlus ARK wiring (ARK_* env), exactly as before.
 * "higgsfield": nothing routes to ByteDance ARK. Seedance runs on Higgsfield,
 * Seedream rows fall back to GPT Image (OpenRouter), ARK-only rows are hidden.
 *
 * Opt in with STUDIO_MEDIA_PROVIDER=higgsfield (Convex env; NEXT_PUBLIC_STUDIO_MEDIA_PROVIDER for the UI).
 */
export type StudioMediaProvider = "higgsfield" | "ark";

export const STUDIO_MEDIA_PROVIDER_DEFAULT: StudioMediaProvider = "ark";

export function studioMediaProvider(): StudioMediaProvider {
  const env = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process?.env;
  const raw = (
    env?.STUDIO_MEDIA_PROVIDER ||
    env?.SEEDANCE_PROVIDER ||
    env?.NEXT_PUBLIC_STUDIO_MEDIA_PROVIDER ||
    STUDIO_MEDIA_PROVIDER_DEFAULT
  )
    .trim()
    .toLowerCase();
  return raw === "higgsfield" ? "higgsfield" : "ark";
}

export function arkEnabled(): boolean {
  return studioMediaProvider() === "ark";
}

export class ArkDisabledError extends Error {
  constructor(what: string) {
    super(`${what} is unavailable: Studio media runs on Higgsfield (ByteDance ARK is switched off).`);
    this.name = "ArkDisabledError";
  }
}

export function assertArkEnabled(what: string): void {
  if (!arkEnabled()) throw new ArkDisabledError(what);
}
